import React from "react";
import styles from "../css/delivery-table.module.css";

// Local table rendering to allow a Collection-like header strip
export default function DeliveryTable({ columns, data, onRowClick }) {
  const template = columns.map((c) => c.width || "1fr").join(" ");
  const gridCols = { gridTemplateColumns: template };

  return (
    <div className={styles.tableCard}>
      {/* Header strip matches Collection look */}
      <div className={styles.headerStrip} style={gridCols}>
        {columns.map((col) => (
          <div key={col.header} className={styles.th}>
            {col.headerRender ? col.headerRender() : col.header}
          </div>
        ))}
      </div>

      {/* Simple body rows (neutral styling) */}
      <div className={styles.body}>
        {data.map((row, idx) => (
          <div
            key={idx}
            className={`${styles.tr} ${onRowClick ? styles.clickable : ''}`}
            style={gridCols}
            onClick={onRowClick ? () => onRowClick(row) : undefined}
          >
            {columns.map((col) => (
              <div key={col.header} className={styles.td}>
                {col.render ? col.render(row[col.accessor], row) : row[col.accessor] ?? ""}
              </div>
            ))}
          </div>
        ))}
        {data.length === 0 && <div className={styles.empty}>No results</div>}
      </div>
    </div>
  );
}
